import { render, staticRenderFns } from "./year_to_year_chart.vue?vue&type=template&id=b18a66ae&"
import script from "./year_to_year_chart.vue?vue&type=script&lang=js&"
export * from "./year_to_year_chart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports